import { ApolloLink } from '@apollo/client'

import { newVersionBanner } from '@/components'

export let oldVersion = ''
export const checkVersionLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((r) => {
    const newVersion = operation.getContext().response.headers.get('x-server-version')
    if (newVersion) {
      if (!oldVersion) {
        oldVersion = newVersion
      }
      if (newVersion !== oldVersion) {
        newVersionBanner(true)
      }
    }
    return r
  })
})
